


























































import {Component, Prop, Vue} from 'vue-property-decorator'
import StaticLabel from "@/components/util/StaticLabel.vue";
import spacetime, {Spacetime} from "spacetime";

type TaxDetails = {
    niNumber?: string;
    utrNumber?: string;
    dateBeganSelfEmployment?: string;
}

@Component({
    components: { StaticLabel }
})
export default class UserTaxDetails extends Vue {

    @Prop()
    userTaxDetailsProp!: TaxDetails;

    private userTaxDetails: TaxDetails = { ...this.userTaxDetailsProp };
    private dateBeganSelfEmployment: Spacetime | null = this.userTaxDetailsProp.dateBeganSelfEmployment ? spacetime(this.userTaxDetailsProp.dateBeganSelfEmployment) : null;

    private isEditing: boolean = false;
    private loading: boolean = false;

    private cancelEditing() {
        this.isEditing = false;
        this.userTaxDetails = { ...this.userTaxDetailsProp };
    }

    private formattedDate(date: string): string {
        if (date) {
            return spacetime(date).format('numeric-uk').toString();
        }
        return 'N/A';
    }
}
